import { Component, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveymcssother",
    template: `<ng-container>
      @for (option of $any(props.options); track option; let i = $index) {
        <div
          class="checkbox checkbox-primary"
          >
          <input
            type="checkbox"
            class="cursor-hand"
            [value]="option.value"
            [id]="id + '_' + i"
            [checked]="myModel === option.value"
            [ngModel]="option.value === myModel"
            (ngModelChange)="onModelChange(option.value)"
            [formlyAttributes]="field"
            [disabled]="props.disabled"
            />
            <label [for]="id + '_' + i" class="cursor-hand">{{ option.label }}</label>
          </div>
        }
        <div class="checkbox checkbox-primary" style="margin-top:5px;">
          <input
            type="checkbox"
            [id]="id + '_other'"
            [checked]="otherValue.length > 0"
            style="padding-top:4px;"
            />
            <label [for]="id + '_other'">
              <input
                class="form-control form-inline"
                [ngClass]="{ 'font-bold': otherValue.length > 0 }"
                [ngModelOptions]="{ updateOn: 'blur' }"
                placeholder="Other..."
                [ngModel]="otherValue"
                (ngModelChange)="onOtherChange($event)"
                [disabled]="props.disabled"
                />
              </label>
            </div>
            @if (props.question?.showCommentBox) {
              <br />
              <mat-form-field appearance="fill" floatLabel="always" class="comments">
                <mat-label>Comments</mat-label>
                <textarea
                  [id]="props.question?.id + '-comments'"
                  [ngModel]="commentModel"
                  rows="4"
                  class="form-field"
                  matInput
                  (blur)="onBlurEvent($event)"
                  [disabled]="props.disabled"
                ></textarea>
              </mat-form-field>
            }
          </ng-container>`,
    styleUrls: ["./common.css"],
    standalone: false
})
export class FormlyFieldSurveyMcssOtherComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  public myModel = null;
  public otherValue = "";
  public commentModel: string;
  commentKey: string;

  ngOnInit(): void {
    const modelValue: string = this.model[this.key.toString()] || "";

    if (modelValue.startsWith("other::")) {
      this.otherValue = modelValue.replace("other::", "");
    }

    this.myModel = this.model[this.key.toString()] || "";

    this.commentKey = this.key.toString() + "-comments";
    this.commentModel = this.model[this.commentKey] || "";
  }

  public onModelChange(newValue) {
    // special case where newValue === this.myModel
    // means the user de-selected the value
    this.myModel = newValue !== this.myModel ? newValue : "";

    this.otherValue = "";
    this.formControl.setValue(this.myModel);
  }

  public onOtherChange(newValue) {
    this.otherValue = newValue;

    newValue = newValue.trim() === "" ? "" : "other::" + newValue;

    this.myModel = newValue;
    this.formControl.setValue(newValue);
  }

  onBlurEvent(event: any) {
    this.model[this.commentKey] = event.target.value;
    this.formControl.updateValueAndValidity();
  }
}
